import { Pipe, PipeTransform } from '@angular/core';
import { UserRole } from '@fleet-beat/core';
import { AuthService } from '@fleet-beat/shared';

@Pipe({
  name: 'disallowAccessByRoles',
})
export class DisallowAccessByRolesPipe implements PipeTransform {
  constructor(private authService: AuthService) {}
  transform(rolesToDisallow: `${UserRole}`[]): boolean {
    return !rolesToDisallow.includes(this.authService?.authUser?.role);
  }
}
